import './contact'
import './menu'
import './sliders'
import './ctas'
import './khazad'
import './vp-slider'

/*
 * JQuery
 */
const $ = jQuery
$(document).ready(function () {
    const scrollHandler = function () {
        const scrollLenght = $(document).scrollTop()

        if (scrollLenght > 0) {
            $('#my-header').addClass('--fixe')
        } else {
            $('#my-header').removeClass('--fixe')
        }
    }
    $(document).scroll(scrollHandler)
    scrollHandler()

    /*
     * Change language
     */

    $('.c-language').click(function () {
        $(this).toggleClass('--open')
    })

    /*
     * Set active on links
     */
    function activeLinks() {
        // console.log(window.location.search);
        if (window.location.search) {
            $(
                'a[href^="' + location.pathname + window.location.search + '"]'
            ).addClass('active')
        }
    }

    activeLinks()
})
